import React from "react";
import NewsSpaHero from "../sections/NewsSpaHero";
import FullInfo from "../sections/FullInfo";
import Contact from "../sections/Contact";

const NewsSpa = () => {
  return (
    <div>
      <NewsSpaHero />
      <FullInfo />
      <Contact />
    </div>
  );
};

export default NewsSpa;
